import React from "react";
import { Row, Col } from "react-bootstrap";
import { Icon } from "semantic-ui-react";
import { Marker } from "react-google-maps";

import { FETCH_URL } from "../../utilities";

const { compose, lifecycle, withStateHandlers } = require("recompose");
const { withScriptjs, withGoogleMap, GoogleMap } = require("react-google-maps");

const AgencyMap = compose(
  withScriptjs,
  withGoogleMap,
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen,
      }),
    }
  ),
  lifecycle({
    componentDidMount() {
      const google = window.google;
      let bounds = new google.maps.LatLngBounds();
      const MARKERS = (
        <Marker
          key={this.props.stop.lat}
          position={{
            lat: parseFloat(this.props.stop.lat),
            lng: parseFloat(this.props.stop.lng),
          }}
          icon="/images/POI_marker.png"
        ></Marker>
      );

      let latlng = {
        lat: parseFloat(this.props.stop.lat),
        lng: parseFloat(this.props.stop.lng),
      };
      bounds.extend(latlng);

      this.setState({
        markers: MARKERS,
        center: bounds.getCenter(),
      });
    },
  })
)((props) => (
  <GoogleMap
    defaultZoom={15}
    center={props.center}
    defaultOptions={{
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            { saturation: 36 },
            { color: "#333333" },
            { lightness: 40 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f6f6f6" }, { lightness: "-11" }],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-10" }],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-12" }],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#693b1d" }, { lightness: 19 }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            { color: "#e9e9e9" },
            { lightness: "-47" },
            { saturation: "0" },
          ],
        },
      ],
    }}
  >
    {props.markers}
  </GoogleMap>
));

class OSAllAgenciesCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      shouldShowCompanies: false,
    };
  }

  state = {
    isMarkerShown: false,
  };

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 3000);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  closeCompanies = () => {
    this.setState({ shouldShowCompanies: false });
  };

  fetchCompanies = (agencyId) => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=fdd25ca34163a64c1bca20de13666dfa/${agencyId}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ shouldShowCompanies: true, companies: responseJson });
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    let refactoredPhone = this.props.tel.replace(new RegExp(",", "g"), ", ");

    let companies = null;
    if (this.state.companies.length > 0) {
      companies = this.state.companies.map((company) => {
        return (
          <div
            key={company.id}
            className="companyItem"
            style={{ width: "100%", float: "left" }}
          >
            {company.name}
            <img
              src={company.imageUrl}
              style={{ width: "auto", height: "20px", float: "right" }}
              alt=""
            />
          </div>
        );
      });
    }
    return (
      <div>
        <Row className="TableRow">
          <Col
            lg={10}
            md={10}
            sm={10}
            xs={10}
            style={{
              borderBottom: "0px solid transparent",
              paddingRight: "0px",
            }}
          >
            <Col lg={5} md={5} sm={5} xs={12} style={{ padding: "0px" }}>
              <div className="portName">
                {this.props.name} / {this.props.address}{" "}
              </div>
            </Col>
            <Col className="removePaddingsOnXS" lg={4} md={4} sm={4} xs={12}>
              <div className="portName">{refactoredPhone} </div>
            </Col>
            <Col lg={3} md={3} sm={3} xs={12} style={{ padding: "0px" }}>
              <div className="portName">{this.props.fax} </div>
            </Col>
          </Col>
          <Col lg={1} md={1} sm={1} xs={1} style={{ padding: "0px" }}>
            {this.props.url !== "" &&
              (this.props.url.indexOf("http://") !== -1 ? (
                <a target="_blank" href={`${this.props.url}`}>
                  <Icon style={{ cursor: "pointer" }} name="at" size="large" />
                </a>
              ) : (
                <a target="_blank" href={`http://${this.props.url}`}>
                  <Icon style={{ cursor: "pointer" }} name="at" size="large" />
                </a>
              ))}
          </Col>
          <Col lg={1} md={1} sm={1} xs={1} style={{ padding: "0px" }}>
            {this.state.shouldShowCompanies ? (
              <Icon
                onClick={() => this.closeCompanies()}
                style={{ cursor: "pointer" }}
                name="x"
                size="large"
              />
            ) : (
              <Icon
                onClick={(agencyId) => this.fetchCompanies(this.props.agencyId)}
                style={{ cursor: "pointer" }}
                name="info circle"
                size="large"
              />
            )}
          </Col>
        </Row>
        {this.state.shouldShowCompanies && <AgencyMap /> && (
          <Row
            style={{
              width: "100%",
              margin: "0px",
              padding: "20px",
              display: "inline-flex",
              borderTop: "2px solid",
              borderBottom: "2px solid",
              background: "white",
            }}
          >
            <div
              style={{
                margin: "0px",
                width: "calc(100% - 50%)",
                display: "inline-block",
              }}
            >
              {companies}
            </div>
            <div
              style={{
                margin: "0px",
                width: "calc(100% - 50%)",
                display: "inline-block",
              }}
            >
              {this.props.lat !== null && this.props.lng !== null ? (
                <AgencyMap
                  stop={{ lat: this.props.lat, lng: this.props.long }}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry"
                  loadingElement={<div style={{ height: `300px` }} />}
                  containerElement={<div style={{ height: `300px` }} />}
                  mapElement={
                    <div
                      style={{
                        height: "300px",
                        marginBottom: "10px",
                        boxShadow: "0px 0px 7px #888888",
                      }}
                    />
                  }
                />
              ) : (
                <AgencyMap
                  stop={{ lat: "37.983810", lng: "23.727539" }}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry"
                  loadingElement={<div style={{ height: `300px` }} />}
                  containerElement={<div style={{ height: `300px` }} />}
                  mapElement={
                    <div
                      style={{
                        height: "300px",
                        marginBottom: "10px",
                        boxShadow: "0px 0px 7px #888888",
                      }}
                    />
                  }
                />
              )}
            </div>
          </Row>
        )}
      </div>
    );
  }
}

export default OSAllAgenciesCard;



// WEBPACK FOOTER //
// ./src/components/OSAgencyCard/OSAllAgenciesCard.js